"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionBorder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DashboardLayoutSectionBorderLine_1 = require("./DashboardLayoutSectionBorderLine");
exports.DashboardLayoutSectionBorder = function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(DashboardLayoutSectionBorderLine_1.DashboardLayoutSectionBorderLine, { position: "top", status: props.status }),
    props.children,
    react_1.default.createElement(DashboardLayoutSectionBorderLine_1.DashboardLayoutSectionBorderLine, { position: "bottom", status: props.status }))); };
//# sourceMappingURL=DashboardLayoutSectionBorder.js.map